<template>
  <div class="login-page">
    <p>Introduzca sus credenciales</p>
    <div class="contents">
      <input v-model="username" placeholder="Nombre de usuario" />
      <input v-model="password" placeholder="Contraseña" type="password" />
      <button @click="onLoginClick">Entrar</button>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";

export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
    };
  },
  methods: {
    async onLoginClick() {
      const loginData = { username: this.username, password: this.password };
      const ok = await this.$auth.login(loginData);
      if (!ok) {
        alert("invalid username or password");
      } else {
        const token = api.authToken;
        localStorage.setItem("auth_token", token);
        this.$router.push("/admin/calendar");
      }
    },
  },
};
</script>

<style scoped>
p {
  text-align: center;
  font-weight: 900;
}

.login-page {
  box-sizing: border-box;
}

.contents {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5em;
  width: 15em;
  margin: 0 auto;
}

input {
  width: 94%;
  padding: 1em 0;
}

button {
  padding: 0.65em 0;
  width: 100%;
}
</style>
